export default {
	ids: [],
	justificativa: String(),
	isBloquear: null,
	idItemAta: null,
}
